import ClearIcon from '@mui/icons-material/Clear'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import FormLabel from '@mui/material/FormLabel'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import { getFieldErrorMessages } from 'global/helpers/form'
import { type ReactElement, type ReactNode } from 'react'
import { Controller, type FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import type { Area } from 'screens/CarrierProfile/CarrierProfile.types'

export interface LaneOrRegionDialogAreasProps extends FieldValues  {
  label: string
}

const LaneOrRegionDialogAreas = ({
  name,
  control,
  rules,
  label,
}: LaneOrRegionDialogAreasProps): ReactNode => {
  const { t } = useTranslation()

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { invalid, error }, formState }): ReactElement => (
        <FormControl fullWidth error={invalid} disabled={formState.isSubmitting}>
          {label && <FormLabel>{label}</FormLabel>}
          {value.length === 0 ? (
            <Typography color="primary.light" variant="p5">
              {t('screens.cs.carrier_profile.lanes_and_regions.form.areas_empty_message')}
            </Typography>
          ) : (
            <List dense disablePadding>
              {value.map((area: Area) => (
                <ListItem
                  key={area.id}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      size="small"
                      onClick={() => {
                        onChange(value.filter((existingArea: Area) => existingArea.id !== area.id)) // NOSONAR
                      }}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  }
                >
                  <ListItemText primary={area.name} />
                </ListItem>
              ))}
            </List>
          )}
          {error?.message && <FormHelperText>{getFieldErrorMessages(error)}</FormHelperText>}
        </FormControl>
      )}
    />
  )
}

export default LaneOrRegionDialogAreas
